import { Injectable } from '@angular/core';
import {HttpClient, HttpEvent, HttpErrorResponse, HttpEventType} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {environment} from "../../environments/environment";
import { HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ReportService {

    backendUrl: string = environment.apiUrl;
    url_final: string;

     constructor(private http: HttpClient) {
    
    }

    registrar(tipo, fulfilled_status, fecha_inicio, fecha_fin, fecha, estatus_entrada_devolucion, estatus_tickets, estatus_productos, estatus_stock, estatus_publicacion, canal_seleccionado, checkProductosInavtivos) {
      console.log("envio de datos del estatus tickets",estatus_tickets)

      return this.http.get<any>(this.backendUrl + '/rmsfe/generar_reportes?tipo=' + tipo + '&fulfilled_status=' + fulfilled_status + '&fecha_inicio=' + fecha_inicio+ '&fecha_fin=' + fecha_fin + '&fecha=' + fecha +'&estatus_entrada_devolucion=' + estatus_entrada_devolucion+'&estatus_tickets=' + estatus_tickets+'&estatus_productos=' + estatus_productos+'&estatus_stock=' + estatus_stock+'&estatus_publicacion=' + estatus_publicacion+'&canal_seleccionado=' + canal_seleccionado + '&productos_inavtivos=' + checkProductosInavtivos, { })
        .pipe(map(confirmacion => {
       
            // console.log("entramos en respuesta de report service")
            // console.log(confirmacion)
            return confirmacion;
        }));
    }

    registrarInventario(tipo, fecha) {
      // console.log("entramos en registrar")

      return this.http.get<any>(this.backendUrl + '/rmsfe/generar_reportes?tipo=' + tipo+'&fecha='+fecha, { })
        .pipe(map(confirmacion => {
       
            // console.log("entramos en respuesta de report service")
            // console.log(confirmacion)
            return confirmacion;
        }));
    }

    consultarReporte(tipo){
      this.url_final = this.backendUrl + "/rmsfe/consultar_status_reporte?tipo="
      this.url_final = `${this.url_final}${tipo}`;
      return this.http.get<any>(this.url_final,  {observe: 'response'})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarProgreso(){
      this.url_final = this.backendUrl + "/rmsfe/query_reports"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final,  {observe: 'response'})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }


}